import React from 'react';
import clsx from 'clsx';
import style from './style.module.scss';
import { SimpleCircleChart } from 'components/charts';

const BasketballViewRecord = ({ item }) => {
  const { teams } = item;
  const { home, away } = teams;

  return (
    <>
      <dl className={style.item}>
        <dt>순위</dt>
        <dd
          className={clsx(
            away.seasonRecord.ranking < home.seasonRecord.ranking && style.on
          )}
        >
          {away.seasonRecord.ranking}위
        </dd>
        <dd
          className={clsx(
            home.seasonRecord.ranking < away.seasonRecord.ranking && style.on
          )}
        >
          {home.seasonRecord.ranking}위
        </dd>
      </dl>

      <dl className={style.item}>
        <dt>승/패</dt>
        <dd>
          {away.seasonRecord.winCount}/{away.seasonRecord.defeatCount}
        </dd>
        <dd>
          {home.seasonRecord.winCount}/{home.seasonRecord.defeatCount}
        </dd>
      </dl>

      <dl className={clsx(style.item, style.rate)}>
        <dt>승률</dt>
        <dd>
          <SimpleCircleChart
            value={Math.round(away.seasonRecord.winPercentage)}
            text={away.seasonRecord.winPercentage}
          />
        </dd>
        <dd>
          <SimpleCircleChart
            value={Math.round(home.seasonRecord.winPercentage)}
            text={home.seasonRecord.winPercentage}
          />
        </dd>
      </dl>
      <dl className={style.item}>
        <dt>득점</dt>
        <dd>{away.seasonRecord.averageScore}</dd>
        <dd>{home.seasonRecord.averageScore}</dd>
      </dl>
      <dl className={clsx(style.item, style.rate)}>
        <dt>야투</dt>
        <dd>
          <SimpleCircleChart
            value={Math.round(away.seasonRecord.fieldGoalSuccessRate)}
            text={away.seasonRecord.fieldGoalSuccessRate}
          />
        </dd>
        <dd>
          <SimpleCircleChart
            value={Math.round(home.seasonRecord.fieldGoalSuccessRate)}
            text={home.seasonRecord.fieldGoalSuccessRate}
          />
        </dd>
      </dl>
      <dl className={clsx(style.item, style.rate)}>
        <dt>3점</dt>
        <dd>
          <SimpleCircleChart
            value={Math.round(away.seasonRecord.threePointShotSuccessRate)}
            text={away.seasonRecord.threePointShotSuccessRate}
          />
        </dd>
        <dd>
          <SimpleCircleChart
            value={Math.round(home.seasonRecord.threePointShotSuccessRate)}
            text={home.seasonRecord.threePointShotSuccessRate}
          />
        </dd>
      </dl>
      <dl className={clsx(style.item, style.rate)}>
        <dt>자유투</dt>
        <dd>
          <SimpleCircleChart
            value={Math.round(away.seasonRecord.freeThrowSuccessRate)}
            text={away.seasonRecord.freeThrowSuccessRate}
          />
        </dd>
        <dd>
          <SimpleCircleChart
            value={Math.round(home.seasonRecord.freeThrowSuccessRate)}
            text={home.seasonRecord.freeThrowSuccessRate}
          />
        </dd>
      </dl>
    </>
  );
};

export default BasketballViewRecord;
